import { IAccountChangeStatus } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import Button from '../../components/Button';
import Theme from '../../theme';
import { defaultScale } from '../../utils';
import { InfoAlert } from './InfoAlert';

interface IProps {
  accountStatusChangeValidation?: IAccountChangeStatus;
  goBack: () => void;
  t: (key: string) => string;
}

export const InvalidAccountChangeMessage: FunctionComponent<IProps> = (
  {
    accountStatusChangeValidation,
    goBack,
    t,
  },
) => {
  return (
    <View style={styles.container}>
      <InfoAlert
        message={accountStatusChangeValidation?.message}
        messageHeading={accountStatusChangeValidation?.messageHeading}
      />
      <Button
        fontColor={Theme.WHITE}
        title={t('invalidAccountChangeBackButton')}
        onPress={goBack}
        containerStyle={{ marginTop: defaultScale(10) }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    margin: defaultScale(10),
  },
});
